<template>
  <nav>
    <div class="nav-inner">
      <img :src="baseUrl + logo" class="logo">
      <ul class="menu">
        <router-link to="home" class="menu-item">首页</router-link>
        <router-link to="hall" class="menu-item">办事大厅</router-link>
        <router-link to="apps" class="menu-item" v-if="isLogin">应用中心</router-link>
        <router-link to="task" class="menu-item" v-if="isLogin">任务中心</router-link>
      </ul>
      <div class="profile" v-if="isLogin">
        <div class="username">{{ userInfo.name }}</div>
        <el-dropdown trigger="hover">
          <img class="avatar" :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../../assets/avatar.jpg')" width="42">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="$router.push('personal')" v-if="userInfo.userDict != 4">个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="login" @click="login" v-else>登录</div>
    </div>
  </nav>
</template>

<script>
import { getUserInfo, logoutApi } from '../../layout/api'
const { jumpURL } = projectConfig

export default {
  name: 'Navigation',
  data() {
    return {

      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      isLogin: localStorage.getItem('sys_token'),
      jumpURL,
      loginType: localStorage.getItem('loginType'),
      casLoginUrl: localStorage.getItem('casLoginUrl'),
    }
  },
  async created() {
    if (this.isLogin) {
      const { data } = await getUserInfo()
      this.userInfo = data
      localStorage.setItem('userInfo', JSON.stringify(data))
    }
  },
  methods: {
    login() {
      if (this.loginType == 1) {
        window.location.href = `${this.jumpURL}/#/login`
      } else if (this.loginType == 2) {
        window.location.href = `${this.casLoginUrl}/login`
      }
      // window.location.href = `http://192.168.1.103:7070/cas/login`
    },
    async logout() {

      // window.location.href = `${this.jumpURL}/#/home`
      this.$confirm('确定退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.loginType == 1) {
          await logoutApi()
        } else if (this.loginType == 2) {
          window.location.href = `${this.casLoginUrl}/logout`
        }
        localStorage.clear()
        window.location.href = `${this.jumpURL}/#/home`
        location.reload()
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: $mainColor;
    z-index: -1;
  }

  .nav-inner {
    width: var(--inner-width);
    height: var(--nav-height);
    margin: auto;
    display: flex;
    align-items: center;

    .logo {
      height: 70%;
    }

    .menu {
      height: 100%;
      display: flex;
      margin: 0 50px 0 80px;
      gap: 80px;

      &-item {
        padding: 0 5px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: #fff;
        border-bottom: 4px solid transparent;
        font-weight: normal;
        transition: 300ms;
        white-space: nowrap;

        &:hover {
          color: #fff;
        }

        &.router-link-active {
          border-color: #fff;
          -webkit-text-stroke: .5px #fff
        }
      }
    }

    .profile {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 20px;

      .username {
        font-size: 18px;
        color: #f9fbfc;
        white-space: nowrap;
      }

      .avatar {
        border-radius: 50%;
        cursor: pointer;
      }
    }

    .login {
      margin-left: auto;
      font-size: 18px;
      font-weight: bold;
      padding: 10px 30px;
      color: #fff;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.3);
      cursor: pointer;
    }
  }
}
</style>